<template>
<div>
	<div class="title">
		<div>
			<h1>Gestion des Clients<i class="fa fa-refresh fa-spin" aria-hidden="true"></i></h1>
		</div>
	</div>
	<v-dialog/>
	<modal 	name="modal-confirm"
			:classes="['v--modal', 'modal-confirm']"
			:pivot-y="0.2"
			:width="400"
			:height="125">
		<div class="confirm-modal-content">
			<div class="modal-title">
				<h6>Voulez-vous désactiver le client <b>{{this.name}}</b></h6>
			</div>
			<div class="modal-button">
				<button @click="$modal.hide('modal-confirm')">Annuler</button>
				<button @click="destroy">Confirmer</button>
			</div>
		</div>
	</modal>
	<div class="row main-wrap">
		<div class="col-md-6 col-lg-7">
			<div class="onglet">
				<h3>Liste des clients</h3>
			</div>
			<div class="section-bg">
				<div id="filter-form-container" class="create-btn ">
					<button type="submit" class="green-btn" v-on:click="clear">
					<i class="fa fa-folder-open" aria-hidden="true"></i>
					Nouveau
					</button>
				</div>
				<table class="table table-striped table-bordered">
					<thead>
						<tr>
							<th data-toggle="true">
								Nom du client
							</th>
							<th data-breakpoints="x-small small medium large">
								Entité
							</th>
							<th data-type="number">
								Jours vendus par mois
							</th>
							<th>Répartition</th>
							<th data-type="number" data-breakpoints="x-small medium">
								Solde du compte&#45;temps
							</th>
						</tr>
					</thead>
					<tbody>
						<tr class="table-row" :key="client.id" v-for="client in allClients" v-on:click="fill(client, $event)">
							<td>{{ client.user.name }}</td>
							<td>
								<ul v-if="client.entite.length > 0">
									<li v-for="entite in client.entite">{{ entite.name }}</li>
								</ul>
							</td>
							<td>{{ client.nbjour }}</td>
							<td >
								<ul v-if='client.utilisateur !== null'>
									<li v-for='utilisateur in client.utilisateur'>
										{{utilisateur.user.name}} {{ utilisateur.user.surename}}
									</li>
								</ul>
							</td>
								<!--<ul v-if="client.entite.length > 0">
									<li v-for="entite in client.entite">{{ client.utilisateur.user.name }}</li>
								</ul> -->
							<td>{{ client.solde }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<div class="col-md-6 col-lg-5">
			<div class="onglet">
				<h3>Profil du client</h3>
			</div>
			<div class="section-bg default-form" v-if="display">
				<div>
					<div class="ligne"></div>
					<p>Créer modifier ou suprimer un client</p>
					<div class="ligne"></div>
				</div>
			</div>
			<div class="section-bg" v-else>
				<div class="row">
					<div class="form-group col-sm-6">
						<label for="name">Nom</label>
						<input type="text" id="name" class="form-control" v-model="name" required>
					</div>
					<!--<div class="form-group col-sm-6">
						<label for="email">E-mail</label>
						<input type="email" id="email" class="form-control" placeholder="gavin.belson@hooli.com" v-model="email" required>
					</div>-->
					<div class="wrap form-group col-sm-6">
						<div class="checkbox">
							<input id="check" type="checkbox" name="check" value="check" v-model="removeUser">
							<label for="check">Désactiver le profil</label>
						</div>
					</div>
				</div>

				<div class="row">
					<div class="form-group col-sm-12 input_fields_wrap entites-wrap">
						<label for="entite">Entité</label>
						<div class="row mb" v-if="entites.length === 0 && new_entites.length === 0">
							<div class="col-md-12">
								<button class="add_field_button grey-button"
										@click="addEntite">+</button>
							</div>
						</div>
						<div class="row mb" v-for="(entite, index) in entites">
							<div class="col-xs-8">
								<input 	type="text" class="form-control"
										required
										v-model="entite.name">

							</div>
							<div class="col-md-4">
								<button class="remove_field_button grey-button" @click="removeEntite(index)">-</button>
								<button class="add_field_button grey-button"
										@click="addEntite"
										v-if="index === (entites.length + new_entites.length) - 1">+</button>
							</div>
						</div>

						<div class="row mb" v-for="(new_entite, index) in new_entites">
							<div class="col-xs-8">
								<input type="text" class="form-control" v-model="new_entite.value">
							</div>
							<div class="col-md-4">
								<button class="remove_field_button grey-button" @click="removeNewEntite(index)">-</button>
								<button class="add_field_button grey-button"
										@click="addEntite"
										v-if="index ===  new_entites.length - 1">+</button>
							</div>
						</div>
					</div>
				</div>
				<hr class="hr-text" data-content="vendu au client">
				<!--
				<div class="form-group">
					<label for="password">Password</label>
					<input type="password" id="password" class="form-control" v-model="password" required>
				</div> -->
				<div class="row">
					<div class="form-group col-sm-4">
						<input type="number" min="1" id="nbheure" class="form-control" v-model="nbheure" :disabled="disabled1 == 1 ? true : false" :class="{disabled1 : disabled}" required />
						<label class="center" for="nbheure">Heures facturées par jour</label>
					</div>
					<div class="form-group col-sm-4">
						<input type="number" min="1" id="nbjour" class="form-control" v-model="nbjour" :disabled="disabled2 == 1 ? true : false" :class="{disabled2 : disabled}" required />
						<label class="center" for="nbjour">Jours vendus par mois</label>
					</div>
					<div class="form-group col-sm-4">
						<input type="number" min="1" id="temps" class="form-control" v-model="soldeCompteTemps" :disabled="disabled3 == 1 ? true : false" :class="{disabled3 : disabled}" required />
						<label class="center" for="temps">Solde du compte&#45;temps</label>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-4 text-center">
						<span class="update" v-on:click="modifyHeure" v-if="disabled1 == true">Modifier</span>
						<span class="update" v-on:click="cancel_modifyHeure" v-if="disabled1 == false">Annuler</span>
					</div>
					<div class="col-sm-4 text-center">
						<span class="update" v-on:click="modifyMois" v-if="disabled2 == true">Modifier</span>
						<span class="update" v-on:click="cancel_modifyMois" v-if="disabled2 == false">Annuler</span>
					</div>
					<div class="col-sm-4 text-center">
						<span class="update" v-on:click="modifyTemps" v-if="disabled3 == true">Modifier</span>
						<span class="update" v-on:click="cancel_modifyTemps" v-if="disabled3 == false">Annuler</span>
					</div>
				</div>
				<hr class="hr-text" data-content="repartition des jours vendus">

				<div class="row">
					<div class="col-sm-8">
						<div class="row">
							<div class="col-sm-8">
								<label for="utilisateur">Personnes assignées</label>
							</div>
							<div class="col-sm-4">
								<label for="jours">Jours</label>
							</div>
						</div>
					</div>
				</div>

				<div class="row mb" v-if="adduser.length === 0">
					<div class="col-sm-8">
						<button class="add_field_button grey-button" @click="addUtilisateur">+</button>
					</div>
				</div>

				<div v-if="adduser != undefined">
					<div v-for="(userAdd, index) in adduser">

						<div class="row mb" v-if="adduser.length === 0 && disabled === 0">
							<div class="col-md-12">
								<button class="add_field_button grey-button" v-if="index === adduser.length - 1" @click="addUtilisateur">+</button>
							</div>
						</div>

						<div class="row mb">
							<div class="col-xs-8">
								<div class="row">
									<div class="col-sm-8">
										<select v-model="userAdd.id" placeholder="Choose here" @change="selectPerson()">
											<option value="Choisir une personne assignee" selected>Choisissez une personne assignée</option>
											<option v-for="user in allUsers" v-bind:value="user.id">{{user.user.name}}</option>
										</select>
									</div>
									<div class="col-sm-4">
										<input type="number" min="1" id="jours" class="form-control" v-model="userAdd.temps.temps"/>
									</div>
								</div>
							</div>
							<div class="col-sm-4">
								<button class="remove_field_button grey-button" @click="removeUtilisateur(index)">-</button>
								<button class="add_field_button grey-button"  v-if="index === adduser.length - 1" @click="addUtilisateur">+</button>
							</div>
						</div>
					</div>
				</div>
				<div class="submit-btn">
					<button type="submit" class="green-btn" v-on:click="submitForm">Sauvegarder</button>

				</div>
			</div>
		</div>
	</div>
</div>
</div>
</template>
<script>
import Vue from '../js/app.js';
import user from '../js/users.js';
import clients from '../js/clients.js';
import active from '../js/active.js';
import footable from'../js/footable.js';

export default {
	data() {
		return {
			id: null,
			name: null,
			email: null,
			password: null,
			nbheure: null,
			nbjour: null,
			temps: null,
			iduser: [],
			adduser: [],
			entites: [],
			response: null,
			allUsers: [],
			allClients: null,
			utilisateurtemps: null,
			disabled: 0,
			disabled1: 1,
			disabled2: 1,
			disabled3: 1,
			removeUser: false,
			updateUser: true,
			createUser:false,
			isActive: false,
			new_entites: [],
			display: true,
			disabledButton: false,
			soldeCompteTemps: null,
		}
	},
	beforeCreate: function () {
		this.$nextTick(function () {
			this.users();
			this.clients();
		})
	},
	methods: {
		users() {
			Vue.http.get(
				'api/utilisateurs/',
			).then(response => {
				this.allUsers = _.orderBy(response.data.data, 'name')
			})
		},
		clients() {
			Vue.http.get(
				'/api/client',
			).then(response => {
				this.allClients = _.orderBy(response.data.data, 'name')
				return this.allClients
			}).then(response => {
				footable.fooTable();
			})
		},
		modifyHeure(){
			this.disabled1 = 0;
			this.disabledButton = true;
		},
		cancel_modifyHeure() {
			this.disabled1 = 1;
			this.disabledButton = false;
		},
		modifyMois(){
			this.disabled2 = 0;
			this.disabledButton = true;
		},
		cancel_modifyMois() {
			this.disabled2 = 1;
			this.disabledButton = false;
		},
		modifyTemps(){
			this.disabled3 = 0;
			this.disabledButton = true;
		},
		cancel_modifyTemps() {
			this.disabled3 = 1;
			this.disabledButton = false;
		},
		cancel_modify() {
			this.disabled = 1;
			this.disabledButton = false;
		},
		submitForm() {
			if (this.createUser === false && this.updateUser === true && this.removeUser === true) {
				this.show(event); //show modal and if ok(@click=destroy) delete profil
			}
			if (this.createUser === false && this.updateUser === true && this.removeUser === false) {
				this.update(event);
			}
			if(this.createUser === true && this.updateUser === false && this.removeUser === false){
				this.create(event);
			}
		},
		create() {
			clients.create(this, this.name, this.email, this.temps, this.nbjour, this.adduser, this.entites, this.nbheure, this.utilisateurtemps, this.new_entites);
			this.clear();
		},
		update() {
			clients.update(this, this.id, this.name, this.email, this.soldeCompteTemps, this.nbjour, this.adduser, this.entites, this.nbheure, this.utilisateurtemps, this.new_entites);
		},
		destroy() {
      this.$modal.hide('modal-confirm')
      this.clear()

      clients.destroy(this, this.id, () => {
        Vue.http.get(
            '/api/client',
        ).then(response => {
          this.allClients = _.orderBy(response.data.data, 'name')
          console.log(this.allClients);
          // return this.allClients
        }).then(response => {
          footable.fooTable();
        })
      })
		},
		showSuccessCreate() {
			this.$modal.show('dialog', {
				text: 'Le profil a bien été crée',
				class: 'modal-success',
				buttons: [
					{ title: 'Fermer' }
				]
			})
		},
		showSuccessUpdate() {
			this.$modal.show('dialog', {
				text: 'Le profil a bien été modifié',
				class: 'modal-success',
				buttons: [
					{ title: 'Fermer' }
				]
			})
		},
		showSuccessDelete() {
			this.$modal.show('dialog', {
				text: 'Le profil a bien été supprimé',
				class: 'modal-success',
				buttons: [
					{ title: 'Fermer' }
				]
			})
		},
		showError() {
			this.$modal.show('dialog', {
				text: 'Il y a eu une erreur imposible de compléter votre action',
				class: 'modal-error',
				buttons: [
					{ title: 'Fermer' }
				]
			})
		},
		showErrorName() {
			this.$modal.show('dialog', {
				text: 'Le profil doit avoir un Nom',
				class: 'modal-error',
				buttons: [
					{ title: 'Fermer' }
				]
			})
		},
		show() {
			this.$modal.show('modal-confirm')
		},
		clear() {
			this.name = '';
			this.email = '';
			this.password = '';
			this.nbheure = 8;
			this.nbjour = 0;
			this.temps = 0;
			this.iduser = [];
			this.adduser = [];
			this.entites = [];
			this.entiteid = [];
			this.response = '';
			this.utilisateurtemps = '';
			this.disabled = 0;
			this.removeUser = false;
			this.display = false;
			this.disabledButton = true;
			this.new_entites = [];
			this.updateUser = false;
			this.createUser = true;
		},
		fill(client) {
			this.name = client.user.name;
			this.email = client.user.email;
			this.entites = client.entite;
			this.removeUser = false;
			this.nbheure = client.nbheure;
			this.nbjour = client.nbjour;
			this.temps = client.temps;
			this.id = client.user.id;
			this.disabled = 1;
			active.active();
			this.display = false;
			this.disabledButton = false;
			var temps = [];

      //
      // for (time in client.util) {
      //   temps.push(time)
      // }
			this.adduser = client.util;
			this.new_entites= [];
			this.updateUser = true;
			this.createUser = false;
			this.soldeCompteTemps = client.solde;
		},
		addEntite () {
	      	this.new_entites.push({ value: '' });
	      	this.disabledButton = true;
	    },
	    removeEntite(index) {
	    	this.entites.splice(index,1)
	    	this.disabledButton = true;
	    },
	    removeNewEntite(index) {
	    	this.new_entites.splice(index,1)
	    	this.disabledButton = true;
	    },
	    addUtilisateur(){
	    	console.log(this.adduser)
	    	this.adduser.push({value: '',temps:{temps:0}});
	    	this.disabledButton = true;
	    },
	    removeUtilisateur(index){
	    	this.adduser.splice(index,1)
	    	this.disabledButton = true;
	    },
	    selectPerson: function(){
	    	this.disabledButton = true;
	    }
	}
}
</script>

<style lang="scss">
	 @import '../sass/app.scss';
</style>



// WEBPACK FOOTER //
// Clients.vue?625a2e86